import SubmitStep from './SubmitStep.tsx';
import type { StepConfig } from '../../../../technical/wizard/StepConfig.ts';
import type { YieldOptimizerInputFields } from '../yield/YieldOptimizer.validation.ts';

export const config = ({ label }: { label?: string } = {}): StepConfig<YieldOptimizerInputFields> => ({
  label: 'Submit',
  element: <SubmitStep label={label} />,
  fields: [],
});
